import { useEffect, useState } from "react";
import { useBaseParams } from "./useBaseParams";
import { fetchCssCategory } from "../services/api.service";//todo
import useError from "./useError";
import useMobileScreen from "../components/useMobileScreen";

const useCss = () => {
  const { chainId, Lang } = useBaseParams();
  const { setError } = useError();
  const isMobile = useMobileScreen();

  const [cssString, setCssString] = useState('');

  const isFontFace = (category, val) => {
    if(
      (category.settingsCategoryName === "Font Family" && val.settingsKey === "font-face")
      || (val.settingsKey.includes("font-face"))
    )
    {
      return true;
    }
    return false;
  }

  const isTrue = (value) => {
      return String(value == null ? '' : value).trim().toLowerCase() === 'true';
  }

  useEffect(() => {
    if (!cssString) {
      fetchCssCategory(chainId, Lang).then((vars) => {
        if (vars.data && vars.data.length) {
          let resortsGridCSS = "";
          let showGrid = false;
          let fontFaceString = ""; // String to hold font-face definitions
          let newCssString = ":root {\n";
          vars.data.forEach(category => {
            category.keys.forEach(key => {
              key.values.forEach(val => {
                if (val.languageIsoCode === Lang) {
                  if( (isMobile && val.settingsKey.includes("-desktop")) || (!isMobile && val.settingsKey.includes("-mobile"))){
                    return;
                  }

                  if (isFontFace(category, val)) {
                    // Process font-face values
                    const fontFaces = val.value.split(";");
                    fontFaces.forEach(face => {
                      if (face.trim() !== "") {
                        const [fontFamily, fontUrl, fontFormat] = face.split(",");
                        fontFaceString += `
                        @font-face {
                          font-family: '${fontFamily.trim()}';
                          font-display: swap;
                          src: url('${fontUrl.trim()}') format('${fontFormat.trim()}');
                        }\n`;
                      }
                    });
                  }
                  else {

                     switch(val.settingsKey){
                        case "resorts-grid-css-desktop":
                          resortsGridCSS = val.value;
                          break;
                        case "IsResortsListHorizontal":
                          showGrid = isTrue(val.value);
                          break;
                        default:                      
                        // Process regular CSS variables
                        newCssString += `  --${val.settingsKey}: ${val.value};\n`;

                     }
                     
                  }
                  
                }
              });
            });
          });

          newCssString += "}\n";
          setCssString(fontFaceString + newCssString + (showGrid ? resortsGridCSS : "" )); // Combine font-face and root variables
        }
      }, err => setError("fetchCssCategory failed: " + err.message));
    }
    return () => {
      setCssString('');
    };
  }, []);

  return cssString;
};

export default useCss;
